import React from 'react';
import styled from 'styled-components';
import theme from 'styles/theme';
import { Row, Text } from '../home/MarketItem';

function ProceedableModalContents({ text, textStyle, closeText, proceedText, onClose, onProceed }) {
   return (
      <ProceedableModalContentsWrap>
         <Text style={textStyle}>{text}</Text>
         <ButtonsWrap>
            <CloseBtn onClick={onClose}>{closeText}</CloseBtn>
            <ProceedBtn
               onClick={() => {
                  onProceed();
                  onClose();
               }}
            >
               {proceedText}
            </ProceedBtn>
         </ButtonsWrap>
      </ProceedableModalContentsWrap>
   );
}

export default ProceedableModalContents;

const ProceedableModalContentsWrap = styled.div`
   padding: 32px 16px 28px 16px;
   ${Text} {
      white-space: pre-wrap;
      text-align: center;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: ${theme.color.gray900};
      margin-bottom: 16px;
   }
`;

const ButtonsWrap = styled(Row)`
   gap: 8px;
`;
const CloseBtn = styled.button`
   width: 120px;
   padding: 10px;
   border: none;
   border-radius: 6px;
   background-color: ${theme.color.gray100};
   color: ${theme.color.gray600};
`;
const ProceedBtn = styled.button`
   width: 120px;
   padding: 10px;
   border: none;
   border-radius: 6px;
   background-color: ${theme.color.orange};
   color: ${theme.color.white};
`;
